import { render, staticRenderFns } from "./Matriz.vue?vue&type=template&id=568994e3&scoped=true&"
import script from "./Matriz.vue?vue&type=script&lang=js&"
export * from "./Matriz.vue?vue&type=script&lang=js&"
import style0 from "./Matriz.vue?vue&type=style&index=0&id=568994e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568994e3",
  null
  
)

component.options.__file = "Matriz.vue"
export default component.exports